module.exports = __webpack_public_path__ + "img/senderrand-runner-step-2.be8a6f6b.svg";